import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"

export function HrSubnav() {
  const { t } = useTranslation()
  const links = [
    { to: "/app/hr", label: t("app.hr.subnav.overview"), end: true },
    { to: "/app/hr/employees", label: t("app.hr.subnav.employees") },
    { to: "/app/hr/contracts", label: t("app.hr.subnav.contracts") },
    { to: "/app/hr/leave", label: t("app.hr.subnav.leave") },
    { to: "/app/hr/timesheets", label: t("app.hr.subnav.timesheets") },
    { to: "/app/hr/payroll", label: t("app.hr.subnav.payroll") },
    { to: "/app/hr/app", label: t("app.hr.subnav.app") },
    { to: "/app/hr/onboarding", label: t("app.hr.subnav.onboarding") },
  ]

  return (
    <nav className="flex flex-wrap gap-1 mb-6 border-b border-border pb-3">
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          className={({ isActive }) =>
            `px-3 py-1.5 rounded-lg text-sm transition-colors ${
              isActive ? "bg-primary text-primary-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted"
            }`
          }
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  )
}
